import {
  ChartRow,
  ChartRowElement,
  ChartRowGroup,
  ChartSubsection,
  ChartSubsectionContent,
  ChartSubsectionHeader,
} from "modules/charts-shared";
import { RADIOLOGY_GRID_COLUMNS } from "../radiology-chart/constants";
import { RadiologyInterpretationProps } from "../radiology-chart/types";
import { useFormContext } from "react-hook-form";

function F015Interpretation(props: RadiologyInterpretationProps) {
  const {
    index,
    chartCode,
    encounterId,
    sectionId,
    sectionCode,
    sectionSubCode,
    onRemoveElement,
  } = props;

  const { watch } = useFormContext();
  const sectionDelimiter = `rad.${index}.${chartCode}${sectionId}${sectionCode}${sectionSubCode}`;

  const isQ001A009Checked = Boolean(watch(`${sectionDelimiter}Q001A009`));
  const isQ001A010Checked = Boolean(watch(`${sectionDelimiter}Q001A010`));
  const isQ001A011Checked = Boolean(watch(`${sectionDelimiter}Q001A011`));
  const isQ001A012Checked = Boolean(watch(`${sectionDelimiter}Q001A012`));
  const isQ001A013Checked = Boolean(watch(`${sectionDelimiter}Q001A013`));

  const isQ001A033Checked = Boolean(watch(`${sectionDelimiter}Q001A033`));
  const isQ001A034Checked = Boolean(watch(`${sectionDelimiter}Q001A034`));
  const isQ001A035Checked = Boolean(watch(`${sectionDelimiter}Q001A035`));
  const isQ001A036Checked = Boolean(watch(`${sectionDelimiter}Q001A036`));
  const isQ001A037Checked = Boolean(watch(`${sectionDelimiter}Q001A037`));

  return (
    <ChartSubsection
      header={
        <ChartSubsectionHeader
          showNotesBtn
          showDeleteBtn
          chartId={chartCode}
          encounterId={encounterId}
          sectionId={sectionCode}
          showInteractions={false}
          subsectionId={`${sectionSubCode}_Q001`}
          subsectionLabel="Radius"
          showAuditsBtn={false}
          onDeleteSubSection={() => onRemoveElement(sectionId)}
        />
      }
      content={
        <ChartSubsectionContent>
          <ChartRow gridTemplateColumns={RADIOLOGY_GRID_COLUMNS}>
            <ChartRowGroup>
              <ChartRowElement
                label="Radius:"
                name={`${sectionDelimiter}Q001A001`}
                type="cross-option"
              />
              <ChartRowElement
                label="L"
                name={`${sectionDelimiter}Q001A002`}
                type="cross-option"
              />
              <ChartRowElement
                label="R"
                name={`${sectionDelimiter}Q001A003`}
                type="cross-option"
              />
              <ChartRowElement type="empty" />
            </ChartRowGroup>
            <ChartRowGroup>
              <ChartRowElement
                label="proximal:"
                name={`${sectionDelimiter}Q001A004`}
                type="cross-option"
              />
              <ChartRowElement
                label="head"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A005`}
                type="cross-option"
              />
              <ChartRowElement
                label="neck"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A006`}
                type="cross-option"
              />
              <ChartRowElement
                label="torus"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A007`}
                type="cross-option"
              />
              <ChartRowElement
                label="SH:"
                name={`${sectionDelimiter}Q001A008`}
                type="cross-option"
              />
              <ChartRowElement
                label="1"
                name={`${sectionDelimiter}Q001A009`}
                type="cross-option"
                isDisabled={
                  isQ001A010Checked ||
                  isQ001A011Checked ||
                  isQ001A012Checked ||
                  isQ001A013Checked
                }
              />
              <ChartRowElement
                label="2"
                name={`${sectionDelimiter}Q001A010`}
                type="cross-option"
                isDisabled={
                  isQ001A009Checked ||
                  isQ001A011Checked ||
                  isQ001A012Checked ||
                  isQ001A013Checked
                }
              />
              <ChartRowElement
                label="3"
                name={`${sectionDelimiter}Q001A011`}
                type="cross-option"
                isDisabled={
                  isQ001A009Checked ||
                  isQ001A010Checked ||
                  isQ001A012Checked ||
                  isQ001A013Checked
                }
              />
              <ChartRowElement
                label="4"
                name={`${sectionDelimiter}Q001A012`}
                type="cross-option"
                isDisabled={
                  isQ001A009Checked ||
                  isQ001A010Checked ||
                  isQ001A011Checked ||
                  isQ001A013Checked
                }
              />
              <ChartRowElement
                label="5"
                name={`${sectionDelimiter}Q001A013`}
                type="cross-option"
                isDisabled={
                  isQ001A009Checked ||
                  isQ001A010Checked ||
                  isQ001A011Checked ||
                  isQ001A012Checked
                }
              />
              <ChartRowElement
                name={`${sectionDelimiter}Q001A014`}
                type="input"
              />
            </ChartRowGroup>
          </ChartRow>
          <ChartRow gridTemplateColumns={RADIOLOGY_GRID_COLUMNS}>
            <ChartRowGroup>
              <ChartRowElement type="empty" />
            </ChartRowGroup>
            <ChartRowGroup>
              <ChartRowElement
                label="shaft:"
                name={`${sectionDelimiter}Q001A015`}
                type="cross-option"
              />
              <ChartRowElement
                label="transverse"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A016`}
                type="cross-option"
              />
              <ChartRowElement
                label="oblique"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A017`}
                type="cross-option"
              />
              <ChartRowElement
                label="spiral"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A018`}
                type="cross-option"
              />
              <ChartRowElement
                label="segmental"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A019`}
                type="cross-option"
              />
              <ChartRowElement
                label="comminuted"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A020`}
                type="cross-option"
              />
              <ChartRowElement
                label="Galeazzi’s"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A021`}
                type="cross-option"
              />
              <ChartRowElement
                label="greenstick"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A022`}
                type="cross-option"
              />
              <ChartRowElement
                label="‘bent bone’"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A023`}
                type="cross-option"
              />
              <ChartRowElement
                name={`${sectionDelimiter}Q001A024`}
                type="input"
              />
            </ChartRowGroup>
          </ChartRow>
          <ChartRow gridTemplateColumns={RADIOLOGY_GRID_COLUMNS}>
            <ChartRowGroup>
              <ChartRowElement type="empty" />
            </ChartRowGroup>
            <ChartRowGroup>
              <ChartRowElement
                label="distal:"
                name={`${sectionDelimiter}Q001A025`}
                type="cross-option"
              />
              <ChartRowElement
                label="Colles’s"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A026`}
                type="cross-option"
              />
              <ChartRowElement
                label="Smith’s"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A027`}
                type="cross-option"
              />
              <ChartRowElement
                label="Barton’s"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A028`}
                type="cross-option"
              />
              <ChartRowElement
                label="intra-articular"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A029`}
                type="cross-option"
              />
              <ChartRowElement
                label="torus"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A030`}
                type="cross-option"
              />
              <ChartRowElement
                label="styloid"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A031`}
                type="cross-option"
              />
              <ChartRowElement
                label="SH:"
                name={`${sectionDelimiter}Q001A032`}
                type="cross-option"
              />
              <ChartRowElement
                label="1"
                name={`${sectionDelimiter}Q001A033`}
                type="cross-option"
                isDisabled={
                  isQ001A034Checked ||
                  isQ001A035Checked ||
                  isQ001A036Checked ||
                  isQ001A037Checked
                }
              />
              <ChartRowElement
                label="2"
                name={`${sectionDelimiter}Q001A034`}
                type="cross-option"
                isDisabled={
                  isQ001A034Checked ||
                  isQ001A035Checked ||
                  isQ001A036Checked ||
                  isQ001A037Checked
                }
              />
              <ChartRowElement
                label="3"
                name={`${sectionDelimiter}Q001A035`}
                type="cross-option"
                isDisabled={
                  isQ001A033Checked ||
                  isQ001A034Checked ||
                  isQ001A036Checked ||
                  isQ001A037Checked
                }
              />
              <ChartRowElement
                label="4"
                name={`${sectionDelimiter}Q001A036`}
                type="cross-option"
                isDisabled={
                  isQ001A033Checked ||
                  isQ001A034Checked ||
                  isQ001A035Checked ||
                  isQ001A037Checked
                }
              />
              <ChartRowElement
                label="5"
                name={`${sectionDelimiter}Q001A037`}
                type="cross-option"
                isDisabled={
                  isQ001A033Checked ||
                  isQ001A034Checked ||
                  isQ001A035Checked ||
                  isQ001A036Checked
                }
              />
              <ChartRowElement
                name={`${sectionDelimiter}Q001A038`}
                type="input"
              />
            </ChartRowGroup>
          </ChartRow>
          <ChartRow gridTemplateColumns={RADIOLOGY_GRID_COLUMNS}>
            <ChartRowGroup>
              <ChartRowElement type="empty" />
            </ChartRowGroup>
            <ChartRowGroup>
              <ChartRowElement
                label="nondisplaced"
                name={`${sectionDelimiter}Q001A039`}
                type="cross-option"
              />
              <ChartRowElement
                label="displaced"
                name={`${sectionDelimiter}Q001A040`}
                type="cross-option"
              />
              <ChartRowElement
                name={`${sectionDelimiter}Q001A041`}
                type="input"
              />
            </ChartRowGroup>
          </ChartRow>
        </ChartSubsectionContent>
      }
    />
  );
}

export { F015Interpretation };
